import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Lock, Sparkles, SlidersHorizontal, X } from "lucide-react";

// Stashes a transfer payload and asks the Vault to open the Secret Vault with it pre-attached.
export function stashTransfer(payload) {
  try { localStorage.setItem("fv_sv_transfer", JSON.stringify(payload)); } catch { /* noop */ }
  window.dispatchEvent(new Event("fv:open-secret-vault"));
}

// A button that asks the user (Guide me / Manual), then moves an item into the Secret Vault.
// `media` = { path, kind, title, source, ref_id?, ref_collection?, body_md? }
export function MoveToVaultButton({ media, className, style, label = "Move to Secret Vault", testid = "move-to-vault-btn" }) {
  const [choosing, setChoosing] = useState(false);
  const go = (mode) => { setChoosing(false); stashTransfer({ mode, media }); };
  return (
    <>
      <button data-testid={testid} onClick={() => setChoosing(true)} className={className}
        style={style || { background: "color-mix(in srgb, var(--accent) 14%, transparent)", border: "1px solid var(--accent)", color: "var(--accent)" }}>
        <Lock size={15} /> {label}
      </button>
      {choosing && createPortal(
        <div className="fixed inset-0 z-[120] flex items-end sm:items-center justify-center" style={{ background: "rgba(0,0,0,0.6)" }} onClick={() => setChoosing(false)} data-testid="move-to-vault-chooser">
          <div onClick={(e) => e.stopPropagation()} className="w-full sm:max-w-sm rounded-t-3xl sm:rounded-3xl p-5" style={{ background: "var(--bg-elevated)", border: "1px solid var(--border)" }}>
            <div className="flex items-center justify-between mb-1">
              <div className="flex items-center gap-2 gold-text"><Lock size={16} /><span className="text-[10px] uppercase tracking-widest">Secret Vault</span></div>
              <button onClick={() => setChoosing(false)} data-testid="move-to-vault-cancel"><X size={18} style={{ color: "var(--text-secondary)" }} /></button>
            </div>
            <div className="font-serif-display text-xl mb-1">How would you like to set this up?</div>
            <p className="text-xs mb-4" style={{ color: "var(--text-secondary)" }}>Choose when it unlocks and who receives it.</p>
            <button onClick={() => go("guide")} data-testid="move-to-vault-guide" className="w-full flex items-center gap-3 rounded-xl p-3 mb-2 text-left" style={{ background: "var(--overlay)", border: "1px solid var(--border)" }}>
              <Sparkles size={18} className="gold-text" /><div><div className="text-sm font-semibold" style={{ color: "var(--text-primary)" }}>Guide me</div><div className="text-[11px]" style={{ color: "var(--text-muted)" }}>Let the AI concierge recommend the best release plan</div></div>
            </button>
            <button onClick={() => go("manual")} data-testid="move-to-vault-manual" className="w-full flex items-center gap-3 rounded-xl p-3 text-left" style={{ background: "var(--overlay)", border: "1px solid var(--border)" }}>
              <SlidersHorizontal size={18} className="gold-text" /><div><div className="text-sm font-semibold" style={{ color: "var(--text-primary)" }}>Manual</div><div className="text-[11px]" style={{ color: "var(--text-muted)" }}>Pick the recipients and conditions yourself</div></div>
            </button>
          </div>
        </div>, document.body)}
    </>
  );
}
